import classNames from 'classnames'
import { ReactNode, useState } from 'react'
import { Button, Collapse } from 'react-bootstrap'
import { useIsMobile } from '../hooks/useMediaQuery'

type Props = {
  children: ReactNode
  className?: string
  // Mostra un pallino sul pulsante "Filtri" quando ci sono filtri attivi
  active?: boolean
}

// Contenitore dei filtri di una lista: su desktop in riga, su mobile
// raccolti sotto un pulsante "Filtri" e impilati uno sotto l'altro
export default function ListFilters({ children, className, active = false }: Props) {
  const isMobile = useIsMobile()
  const [open, setOpen] = useState(false)

  if (!isMobile) {
    return <div className={classNames('d-flex align-items-center w-100 list-filters', className)}>{children}</div>
  }

  return (
    <div className="w-100">
      <Button
        type="button"
        size="sm"
        variant={open ? 'secondary' : 'outline-secondary'}
        className={classNames('d-flex align-items-center', { 'text-white': open })}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="d-flex align-items-center">
          <span className="material-icons-outlined me-2" style={{ fontSize: 17 }}>
            filter_alt
          </span>
          Filtri
          {active && <span className="badge rounded-pill bg-danger ms-2">attivi</span>}
        </span>
        <span className="material-icons ms-1" style={{ fontSize: 18 }}>
          {open ? 'expand_less' : 'expand_more'}
        </span>
      </Button>
      <Collapse in={open}>
        <div>
          <div className="d-flex list-filters pt-2">{children}</div>
        </div>
      </Collapse>
    </div>
  )
}
